<template>
    <div class="d-flex gap-2 align-items-start">
        <div class="flex-grow-1">
            <input type="text" class="form-control flex-grow-1" :class="{ 'is-invalid': error }" :id="id" @input="update($event.target.value)" :title="title" :value="code" v-bind="$attrs" />
            <div class="invalid-feedback" v-if="error">{{ error }}</div>
        </div>
        <div class="hstack mb-auto">
            <img :src="captcha" alt="驗證碼圖片">
            <button class="btn btn-sm btn-icon" @click="refresh" aria-label="重新產生一組驗證碼" title="重新產生一組驗證碼" type="button">
                <img src="assets/img/icon-replay.svg" alt="" aria-hidden="true">
            </button>
        </div>
    </div>
</template>

<script setup>
    const props = defineProps({
        error: { type: String },
        id: { default: () => nextId(), type: String },
        modelValue: { type: [Number, String] },
        title: { default: () => inject("label", ""), type: String },
        type: { default: "text", type: String }
    });

    const captcha = ref();
    const code = ref(props.modelValue);

    const errors = inject("errors", ref({}));
    const ids = inject("ids", ref([]));

    const emit = defineEmits(["update:modelValue"]);

    const refresh = () => {
        captcha.value = window.API_BASE + "/Auth/GetCaptchaImage?" + Date.now();

        update("");
    };

    const update = (value) => {
        code.value = value;

        emit("update:modelValue", value);
    };

    ids.value.push(props.id);

    defineOptions({ inheritAttrs: false });

    defineExpose({ refresh });

    refresh();

    watch(() => props.error, (value) => errors.value[props.id] = value);
</script>
